import React, { lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { FallbackView } from '../../theme/partials';
// import HomePage from '../modules/home/HomePage';
import OnlineBookingPage from '../modules/online-booking/OnlineBookingPage';
import ReportPage from '../modules/reports/ReportPage'
import { PageUrl } from '../utils/common/constants';
import ServiceManagementPage from 'app/modules/service-management/ServiceManagementPage';
import GrowthAndMarketingPage from 'app/modules/growth-marketing/GrowthAndMarketingPage';
import PWAControlPage from 'app/modules/pwa-control/PWAControlPage';
import { WatanCompanyRoute } from './WatanCompanyRoute';

export function PrivateRoutes() {

  const TicketPage = lazy(() => import('../modules/tickets/TicketPage'))
  const UsersPage = lazy(() => import('../modules/users/UserPage'))
  const BusyTimePage = lazy(() => import('../modules/busy-time/BusyTimePage'))
  const CustomerPage = lazy(() => import('../modules/customers/CustomerPage'))
  const HousingPage = lazy(() => import('../modules/operation-setup/housing/HousingPage'))
  const ZonesPage = lazy(() => import('../modules/operation-setup/zones/ZonesPage'))
  const ServicesPage = lazy(() => import('../modules/operation-setup/services/ServicesPage'))
  const DispatchPage = lazy(() => import('../modules/operation-setup/dispatch/DispatchPage'))
  const PaymentGatewayPage = lazy(() => import('../modules/operation-setup/payment-gateway/PaymentGatewayPage'))
  const TripPage = lazy(() => import('../modules/trip/TripPage'))
  const PaymentsPage = lazy(() => import('../modules/payments/PaymentsPage'))
  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        {/* <Route path={PageUrl.HOME} component={HomePage} /> */}
        <Route path={PageUrl.TICKET.ROOT} component={TicketPage} />
        <Route path={PageUrl.USERS.ROOT} component={UsersPage} />
        <Route path={PageUrl.TRIP.ROOT} component={TripPage} />
        <Route path={PageUrl.BUSY_TIME.ROOT} component={BusyTimePage} />
        <Route path={PageUrl.CUSTOMERS.ROOT} component={CustomerPage} />
        <Route path={PageUrl.ONLINE_BOOKING.ROOT} component={OnlineBookingPage} />
        <Route path={PageUrl.REPORTS.ROOT} component={ReportPage} />
        <Route path={PageUrl.SERVICE_MANAGEMENT.ROOT} component={ServiceManagementPage} />
        <Route path={PageUrl.GROWTH_AND_MARKETING.ROOT} component={GrowthAndMarketingPage} />
        <Route path={PageUrl.PWA_CONTROL.ROOT} component={PWAControlPage} />
        <WatanCompanyRoute path={PageUrl.PAYMENTS.PAYMENT_GATEWAY} component={PaymentGatewayPage} />
        <Route path={PageUrl.PAYMENTS.ROOT} component={PaymentsPage} />
        <WatanCompanyRoute path={PageUrl.OPERATION_SETUP.HOUSING} component={HousingPage} />
        <WatanCompanyRoute path={PageUrl.OPERATION_SETUP.ZONES} component={ZonesPage} />
        <WatanCompanyRoute path={PageUrl.OPERATION_SETUP.SERVICES} component={ServicesPage} />
        <WatanCompanyRoute path={PageUrl.OPERATION_SETUP.FIELD_TEAM} component={UsersPage} />
        <WatanCompanyRoute path={PageUrl.OPERATION_SETUP.DISPATCH} component={DispatchPage} />
        <Redirect from='/auth' to='/orders' />
        <Redirect exact from='/' to='/orders' />
        <Redirect to='error/404' />
      </Switch>
    </Suspense>
  )
}
